const routes = [
  {
    path: '/pointmalllast/goodslist',
    name: 'pointmalllast-goodslist',
    component: () => import('@/views/shopping/HomePage.vue'),
    meta: {
      title: '积分商城',
    },
  },
  {
    path: '/pointmalllast/goodsdetail',
    name: 'pointmalllast-goodsdetail',
    component: () => import('@/views/shopping/ShoppingDetails.vue'),
    meta: {
      title: '积分商城',
    },
  },
  {
    path: '/pointmall/singincardexplain',
    name: 'pointmall-singincardexplain',
    component: () => import('@/views/shopping/SinginCardExplain.vue'),
    meta: {
      title: '补签卡使用说明',
    },
  },
  {
    path: '/pointmall/exchangeexplain',
    name: 'pointmall-orderdetail',
    component: () => import('@/views/shopping/ShoppingExchangeExplain.vue'),
    meta: {
      title: '当当网优惠券使用说明',
    },
  },
  {
    path: '/pointmalllast/orderlist',
    name: 'pointmalllast-orderlist',
    component: () => import('@/views/shopping/ShoppingOrder.vue'),
    meta: {
      title: '兑换记录',
    },
  },
  {
    path: '/pointmalllast/orderdetail',
    name: 'pointmalllast-orderdetail',
    component: () => import('@/views/shopping/ShoppingOrderdetail.vue'),
    meta: {
      title: '兑换记录',
    },
  },
  {
    path: '/pointmalllast/swipergoodslist',
    name: 'pointmalllast-swipergoodslist',
    component: () => import('@/views/shopping/HomeSwiperList.vue'),
    meta: {
      title: '积分商城',
    },
  },
  {
    path: '/pointmalllast/shoppingentity',
    name: 'pointmalllast-shoppingentity',
    component: () => import('@/views/shopping/ShoppingEntity.vue'),
    meta: {
      title: '订单确认',
    },
  },
  {
    path: '/pointmalllast/shoppingaddressadd',
    name: 'pointmalllast-shoppingaddressadd',
    component: () => import('@/views/shopping/ShoppingAddressAdd.vue'),
    meta: {
      title: '新建收货地址',
    },
  },
  {
    path: '/pointmalllast/shoppingaddresslist',
    name: 'pointmalllast-shoppingaddresslist',
    component: () => import('@/views/shopping/ShoppingAddressList.vue'),
    meta: {
      title: '收货地址',
    },
  },
  {
    path: '/pointmalllast/coinrule',
    name: 'pointmalllast-starcoinrule',
    component: () => import('@/views/shopping/StarCoinRule.vue'),
    meta: {
      title: '星币规则',
    },
  },
  {
    path: '/pointmalllast/pointrule',
    name: 'pointmalllast-starpointrule',
    component: () => import('@/views/shopping/StarPointRule.vue'),
    meta: {
      title: '星值规则',
    },
  },
  {
    path: '/pointmalllast/rightstatement',
    name: 'pointmalllast-rightstatement',
    component: () => import('@/views/shopping/RightsStatement.vue'),
    meta: {
      title: '会员权益说明',
    },
  },
  {
    path: '/sciencer/unreviewed',
    name: 'sciencer-unreviewed',
    component: () => import('@/views/shopping/UnreviewedPage.vue'),
    meta: {
      title: '科普员用户信息审核',
    },
  },
];
export default routes;
